import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import {
  SeamlessIcon,
  ExquisiteIcon,
  EyecatchingIcon,
  IntuitiveIcon,
  OnPageIcon,
  MobileResponsiveIcon,
  OnDemandIcon
} from "../../../../app-constants";


const Hireexpertweb = () => {
  return (
    <div className="hire_expert tekrevol_dark_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
            <h2>Features & Benefits When You Hire Expert Web Design Company in Dubai</h2>
            <p>When you hire a renowned website development company for your web development project like TekRevol, you get a lot of advantages. TekRevol is a multi-award-winning, renowned, and experienced web design company in Dubai that has years of experience. As per research, 3/4th of all consumers base their website design or development decisions on the benefits and advantages they get along with the service.</p>
            <p>Regarding website development or website design Dubai, we don’t just design or develop them. We deliver on our promise of providing extraordinary outcomes and disseminating value that reaches the audience and positively impacts lives. Websites that we develop are not mere websites but ready-to-market platforms for businesses. Our SEO-optimized websites are crafted delicately so that you get more business and land in front of the right audience.</p>
            <h6>Salient Features of Our Website Development Services That Take Your Business to the next level:</h6>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto">
            <div className="tech_stackgcc">
              <div className="tech_stackbox">
                {SeamlessIcon}
                <div className="tech_stacktitle">
                  <h6>Seamless Design Flow</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {ExquisiteIcon}
                <div className="tech_stacktitle">
                  <h6>Exquisite User Experience (UX)</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {EyecatchingIcon}
                <div className="tech_stacktitle">
                  <h6>Eye-Catching User Interface Design (UI)</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {IntuitiveIcon}
                <div className="tech_stacktitle">
                  <h6>Intuitive Branding /Rebranding</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {OnPageIcon}
                <div className="tech_stacktitle">
                  <h6>On-Page SEO Optimization</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {MobileResponsiveIcon}
                <div className="tech_stacktitle">
                  <h6>Mobile Responsiveness</h6>
                </div>
              </div>
              <div className="tech_stackbox">
                {OnDemandIcon}
                <div className="tech_stacktitle">
                  <h6>On-Demand Backend Functionality</h6>
                </div>
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Hireexpertweb